export const GET_CONVERSATION_DETAILS_RECORDING_AND_TRANSCRIPT =
  'getConversationDetailsRecordingAndTranscript';
export const GET_SERVICE_QUEUES_QUERY = 'getServiceQueuesQuery';
export const GET_SERVICE_USERS_QUERY = 'getServiceUsersQuery';
export const GET_USERS_AVAILABILITY_ACTIVITY_QUERY =
  'getUsersAvailabilityActivityQuery';
export const SET_USER_STATUS_MUTATION = 'setUserStatus';
export const UPDATE_USER_AVAILABILITY_STATUS_MUTATION =
  'setUserAvailabilityStatus';
export const CANCEL_WRAPUP_MUTATION = 'cancelUserWrapupActivity';
export const INTERACTION_CLASSIFICATION_DATA_MUTATION =
  'interactionClassificationData';
export const ADD_CUSTOMER_MUTATION_OPERATION_NAME = 'addCustomer';
export const LINK_CALL_TO_CUSTOMER_AND_LOCATION_OPERATION_NAME =
  'LinkCallToCustomerAndLocation';
